"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Button_1 = require("@material-ui/core/Button");
exports.Button = (_a) => {
    var { outlined, secondary } = _a, props = __rest(_a, ["outlined", "secondary"]);
    const variant = outlined ? 'outlined' : 'contained';
    const color = secondary ? 'secondary' : 'primary';
    return React.createElement(Button_1.default, Object.assign({ variant: variant, color: color }, props));
};
// Button.defaultProps = {
//   variant: "contained",
//   color: "primary"
// };
//# sourceMappingURL=Button.js.map